/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const FlagFilledIcon = /*#__PURE__*/ createSvgIcon(
  'FlagFilledIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M5.5 11v5.25c0 .212-.071.39-.214.534a.72.72 0 01-.532.216.734.734 0 01-.535-.216A.72.72 0 014 16.25V3.75c0-.212.072-.39.216-.534A.726.726 0 014.75 3h5.661c.184 0 .344.053.478.158.135.106.22.24.257.405L11.5 5h3.75c.213 0 .39.072.534.216A.726.726 0 0116 5.75v6.5c0 .213-.072.39-.216.534a.726.726 0 01-.534.216h-3.667a.748.748 0 01-.467-.158.691.691 0 01-.262-.405L10.5 11h-5z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default FlagFilledIcon;
